<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type="" effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img src="img/brand/brand-logo.png" alt="logo" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <a href="#">
            <img src="img/brand/brand-logo2.png" />
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center"></ul>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <a class="nav-link" href="#/about-us" rel="noopener" data-toggle="tooltip">
            About us
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#/services" rel="noopener" data-toggle="tooltip">
            Services
          </a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link" href="#/offer" rel="noopener" data-toggle="tooltip">
            Commercial solutions
          </a>
        </li> -->
        <li class="nav-item">
          <a class="nav-link" href="#/integration-software-services" rel="noopener" data-toggle="tooltip">
            Integration services
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#/contact-us" rel="noopener" data-toggle="tooltip">
            <b>Contact us</b>
          </a>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
};
</script>
<style></style>
